import React, { useEffect } from 'react';

import {
  useResponsiveParams,
  QuantaFormik,
  QuantaForm,
  useQuantaFormikContext,
} from 'quanta-ui';
import InsuranceData from './insuranceData';

export default function InsuranceSummary({
  lobCode,
  lobName,
  productName,
  productCode,
  planName,
  planCode,
  proposalNumber,
  ...props
}) {
  //console.log(lobCode,
    // lobName,
    // productName,
    // productCode,
    // planName,
    // planCode,
    // proposalNumber);
  let repeat = useResponsiveParams({ for_mobile: 1, for_desktop: 3 });

  const validate = (values) => {
    const errors = {};

    return errors;
  };

  const InsuranceDetails = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    //console.log(values);
    const onSubmit = (values) => {};

    const AutoSubmitForm = ({ validate, values }) => {
      useEffect(() => {
        if (values) {
          const errors = validate(values);
          const error_count = Object.keys(errors).length;
          if (error_count === 0) {
            onSubmit(values);
          }
        }
      }, [values]);

      return null;
    };

    return (
      <>
        <QuantaForm className="space-y-4 p-4">
          <InsuranceData
            {...{
              lobCode,
              lobName,
              productName,
              productCode,
              planName,
              planCode,
              proposalNumber,
              props,
            }}
          />
          <AutoSubmitForm {...{ validate, values }} />
        </QuantaForm>
      </>
    );
  };

  return (
    <div>
      <QuantaFormik enableReinitialize={true} {...{ validate }}>
        <InsuranceDetails {...{ validate }} />
      </QuantaFormik>
    </div>
  );
}
